export const InputField = ({
  label,
  name,
  value,
  icon: Icon,
  type = "text",
  disabled = false,
  onChange,
}) => (
  <div className="flex flex-col space-y-2">
    <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">
      {label}
    </label>
    <div className="relative group">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <Icon
          size={18}
          className="text-gray-400 group-focus-within:text-blue-600 transition-colors"
        />
      </div>
      <input
        type={type}
        name={name}
        value={value ?? ""}
        disabled={disabled}
        placeholder={`Enter ${label}`}
        onChange={onChange}
        className={`w-full pl-10 pr-4 py-3 border rounded-lg outline-none transition-all duration-200 
          ${disabled ? "bg-gray-50 border-gray-200 text-gray-400" : "bg-white border-gray-300 focus:border-blue-600 focus:ring-4 focus:ring-blue-100"}`}
      />
    </div>
  </div>
);
